import { render, staticRenderFns } from "./ChurnButton.vue?vue&type=template&id=3130efec&scoped=true&"
import script from "./ChurnButton.vue?vue&type=script&lang=js&"
export * from "./ChurnButton.vue?vue&type=script&lang=js&"
import style0 from "./ChurnButton.vue?vue&type=style&index=0&id=3130efec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130efec",
  null
  
)

export default component.exports